module.exports = __webpack_public_path__ + "static/img/fg3.5133432.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/fg3.png
// module id = vyCb
// module chunks = 0